import type { ApiError } from '@/types/api.types';

type TranslateFn = (key: string) => string;

export function mapStaffError(error: ApiError, t: TranslateFn, fallbackKey: string): string {
  switch (error.code) {
    case 'UNAUTHORIZED':              return t('staff.errors.unauthorized');
    case 'FORBIDDEN':                 return t('staff.errors.forbidden');
    case 'STAFF_NOT_FOUND':           return t('staff.errors.notFound');
    case 'VALIDATION_ERROR':          return t('staff.errors.validationError');
    case 'STAFF_ALREADY_EXISTS':      return t('staff.errors.alreadyExists');
    case 'INVITE_ALREADY_ACCEPTED':   return t('staff.errors.alreadyAccepted');
    case 'CANNOT_MODIFY_OWNER':       return t('staff.errors.cannotModifyOwner');
    case 'CANNOT_ARCHIVE_OWNER':      return t('staff.errors.cannotArchiveOwner');
    case 'INVALID_STATUS_TRANSITION': return t('staff.errors.invalidTransition');
    case 'INTERNAL_ERROR':            return t('staff.errors.serverError');
    default:                          return t(fallbackKey);
  }
}
